<template>
  <div :class="[{ purpose: this.data?.body?.purpose }]">
    <q-linear-progress v-if="this.isFetching" indeterminate/>
    <q-form v-else @submit="this.onSubmit" class="form">
      <div class="form__item">
        <CustomSelect
          :options="this.assignTypes"
          label="Тип назначения"
          optionValueKey="assign_type_id"
          :loading="this.isFetching"
          optionLabelKey="assign_type_name"
          :value="this.formData.assign_type_id || ''"
          @change="this.handleAssignTypeChange"
          :clearable="true"
          :required="true"
        />
      </div>

      <div class="form__item">
        <CustomSelect
          :options="this.contractorsOptions"
          label="Компания"
          optionValueKey="contractor_id"
          optionLabelKey="contractor_name"
          :value="this.formData.contractor_id || ''"
          @change="(value) => this.handleContractorChange(value)"
          :clearable="true"
          :required="contractorsOptionsRequired"
        />
      </div>

      <div class="form__item" >
        <CustomSelect
          :options="this.employeesOptions"
          label="Сотрудник"
          optionValueKey="employee_id"
          optionLabelKey="fio"
          :value="this.formData.employee_id || ''"
          @change="(value) => this.handleEmployeeChange(value)"
          :clearable="true"
          :required="true"
          />
      </div>

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import {
  getAssignTypes,
  getContractorsList,
  getEmployeesListByContractorId,
} from "@/views/ProjectsEntry/services";

export default {
  name: "upd-project-executor",
  components: { CustomInput, CustomSelect, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      assignTypes: [],
      contractorsOptions: [],
      employeesOptions: [],
      assignTypeCode: this.data?.body.assign_type_code || "",
      formData: {
        project_id: this.data?.body.project_id || "",
        project_assign_id: this.data?.body.project_assign_id || "",
        assign_type_id: this.data?.body.assign_type_id || "",
        contractor_id: this.data?.body.contractor_id || "",
        employee_id: this.data?.body.employee_id || "",
      }
    };
  },

  computed: {
    contractorsOptionsRequired() {
      return this.assignTypeCode !== 'OBSERVER';
    }
  },

  async mounted() {
    await this.initializeForm();
  },

  methods: {
    async initializeForm() {
      this.isFetching = true;

      // Загружаем типы назначения и компании
      await Promise.all([
        this.loadAssignTypes(),
        this.loadContractors(),
      ]);

      // Если модалка открыта в режиме редактирования и в теле есть уже выбранные данные,
      // подгружаем список сотрудников так, чтобы текущий исполнитель был виден в выпадающем списке.
      const hasEmployee = !!this.data?.body?.employee_id;
      const hasContractor = !!this.formData.contractor_id;

      if (hasEmployee) {
        // Особый тип назначения без компании (например, OBSERVER / id = 4)
        const isWithoutContractor = this.formData.assign_type_id === 4 || this.assignTypeCode === 'OBSERVER';
        const contractorIdForLoad = isWithoutContractor ? "0" : (hasContractor ? this.formData.contractor_id : "0");

        await this.loadEmployees(contractorIdForLoad, true);
      }

      this.isFetching = false;
    },

    async loadAssignTypes() {
      const res = await getAssignTypes();
      this.assignTypes = res || [];
    },

    async loadContractors() {
      const res = await getContractorsList();
      this.contractorsOptions = res || [];
    },

    async loadEmployees(contractorId, isMount = false) {
      const id = contractorId || 0;

      const res = await getEmployeesListByContractorId(id);
      this.employeesOptions = res || [];
      if(isMount && this.data?.body?.employee_id && !this.employeesOptions?.length) {
        this.employeesOptions = [{employee_id: this.data?.body?.employee_id, fio: this.data?.body?.employee_fio}];
      }
    },

    async handleAssignTypeChange(value, row) {
      this.isFetching = true

      this.formData.assign_type_id = value;
      this.assignTypeCode = row?.assign_type_code || '';
      
      this.formData.contractor_id = "";
      this.formData.employee_id = "";

      if (value === 4) {
        await this.loadEmployees("0");
      }
      this.isFetching = false
    },

    async handleContractorChange(value) {
      this.isFetching = true

      this.formData.contractor_id = value;
      this.formData.employee_id = "";
      
      await this.loadEmployees(value);
      this.isFetching = false
    },

    handleEmployeeChange(value) {
      this.formData.employee_id = value;
    },

    async onSubmit() {
      const {assign_type_id, employee_id, contractor_id} = this.formData
      if (assign_type_id == "" && employee_id == "" && contractor_id == "") {
        return;
      }

      const submitData = { ...this.formData };
      
      this.loading = true;
      await this.data?.onSubmit(submitData);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 20px;

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>